import { 分類リスト } from "./categories"
import constants from "./constant"
import GRID from "./flexGridConstant"
import { LOCALSTORAGE_PROPERTIES } from "./localstorageProperties"
import MESSAGES from "./messages"
import validateConstant from "./validateConstant"
import unsoryoHosyo from "./unsoryoHosyo"

const CONSTANT = {
  GRID,
  LOCALSTORAGE_PROPERTIES,
  分類リスト,
  ...constants,
  MESSAGES,
  validateConstant,
  unsoryoHosyo,
}

export default CONSTANT
